import React, {FC} from 'react';

type Props = {
    className?: any
}

const AsideImage: FC<Props> = ({className}) => {
    return (
        <img src={'/assets/images/home/shadow-all.png'} className={`${className}`} alt={'Placeholder'}/>
    );
};

export default AsideImage;